import eventbus from '@/core/shared/services/EventBus';

export default {
  created () {
    this.__safetyModeMixinUnwatch1 = this.$store.watch(
      (state, getters) => getters.isNetworkAvailable,
      (val, oldVal) => {
        if (val === true && oldVal === false) {
          // goes back online
          console.log('SBVR api is up and running');
          const { safetyMode, stationId, currentStation } = this.$store.getters;
          const { version, playing, playingType, volume } = currentStation;
          if (safetyMode) {
            this.$store.dispatch('updateStation', {
              station: {
                id: stationId,
                version,
                playingId: playing && playing.id,
                playingType,
                volume,
                calling: false,
                safetyMode: true,
              },
              withoutMiddleware: true,
            });
          }
        } else if (val === false && oldVal === true) {
          // goes offline
          console.log('SBVR api is down: activate safety mode');
          eventbus.$emit('safety-mode:activate');
          this.$store.dispatch('activateSafetyMode');
        }
      },
    );
    this.__safetyModeMixinUnwatch2 = this.$store.watch(
      (state, getters) => getters.safetyMode,
      (val, oldVal) => {
        if (val === true && oldVal === false) {
          // goes into safety mode
          this.$store.dispatch('onSafetyModeOn');
          console.log('safety mode is on!');
        } else if (val === false && oldVal === true) {
          // restore
          console.log('safety mode is off!');
          this.$store.dispatch('onSafetyModeOff');
        }
      },
    );
  },
  destroyed () {
    this.__safetyModeMixinUnwatch1 && this.__safetyModeMixinUnwatch1();
    this.__safetyModeMixinUnwatch2 && this.__safetyModeMixinUnwatch2();
  },
};
